import { Component } from 'vue-property-decorator'

import { EditMemberDto } from '@src/dto/edit-member-dto'
import EventBus from '@src/lib/event_bus'
import PersonalInformation from '@src/routes/members/components/account/personal-information'
import { isEmailValid } from '@src/util/validation'

class ErrorResponse {
  errors: {
    base: string
    username: string[]
  }

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}

@Component({
  computed: {
    initialMember () {
      return this.$store.state.selectedMember || this.$store.state.memberProfile
    },
    platformLocale () {
      return this.$store.state.i18n.locale
    }
  }
})
export default class MemberPersonalInformation extends PersonalInformation {

  constructor () {
    super()
    this.emailRequirements = 'PAGE.MEMBERS.ACCOUNT.EMAIL_REQUIREMENTS_TRAINER'
  }

  editProfile (member: EditMemberDto) {
    if (!isEmailValid(this.member.email!)) {
      this.fieldErrors.push('email')
      return undefined
    }
    return this.service.updatePersonalInformation(member, this.initialMember.id)
      .then(() => {
        if (this.member.email !== this.initialMember.email) {
          this.service.updateEmail(this.member.email)
            .then(() => {
              this.$store.dispatch('showToast', {
                message: `${this.$t('PAGE.MEMBERS.ACCOUNT.UNCONFIRMED_EMAIL.TITLE')} ${this.$t('PAGE.MEMBERS.ACCOUNT.UNCONFIRMED_EMAIL.MESSAGE')} ${this.member.email}`,
                fadeOut: false
              })
            })
            .catch((error) => {
              error.status === 409 ? this.fieldErrors.push('email_duplicate') : this.fieldErrors.push('email')
            })
        } else {
          this.$store.dispatch('showToast', { message: this.$t('PAGE.MEMBERS.ACCOUNT.PERSONAL_INFORMATION_SAVED'), fadeOut: true })
          EventBus.trigger('reloadSelectedMember')
        }
      })
      .catch(error => this.setErrors(error.status, new ErrorResponse(error.errorData)))
  }
}
